import { Link } from "react-router-dom"
import { AuthLayout } from "@/components/auth/AuthLayout"
import { ForgotPasswordForm } from "@/components/auth/ForgotPasswordForm"

export function ForgotPasswordScreen() {
  return (
    <AuthLayout>
      <div className="w-full max-w-md">
        <div className="animate-in fade-in slide-in-from-right-5 duration-500 ease-out">
          <header className="mb-10 text-center lg:text-left">
            <h2 className="mb-2 text-3xl font-bold tracking-tight text-foreground">
              Recover Access
            </h2>
            <p className="text-muted-foreground">
              Enter your operator email. We&apos;ll send a reset link to your inbox.
            </p>
          </header>

          <ForgotPasswordForm />
        </div>

        <p className="mt-8 text-center">
          <Link
            to="/"
            className="text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            Back to sign in
          </Link>
        </p>
      </div>
    </AuthLayout>
  )
}
